const getActionsByDocument = DOCUMENT => {
  const actions = {
    LOAD: DOCUMENT + 'LOAD',
    LOAD_MORE: DOCUMENT + 'LOAD_MORE',
    LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
    LOAD_MORE_SUCCESS: DOCUMENT + 'LOAD_MORE_SUCCESS',
    SEND_COMMENT: DOCUMENT + 'SEND_COMMENT',
    SEND_COMMENT_SUCCESS: DOCUMENT + 'SEND_COMMENT_SUCCESS',
    SEND_COMMENT_FAILED: DOCUMENT + 'SEND_COMMENT_FAILED',
    CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',

    loadData: data => ({
      type: actions.LOAD,
      payload: data,
    }),

    loadMore: data => {
      return {
        type: actions.LOAD_MORE,
        payload: data,
      };
    },

    sendComment: data => {
      return {
        type: actions.SEND_COMMENT,
        payload: data,
      };
    },

    sendCommentFailed: () => {
      return {
        type: actions.SEND_COMMENT_FAILED,
      };
    },

    sendCommentSuccess: () => {
      return {
        type: actions.SEND_COMMENT_SUCCESS,
      };
    },

    loadDataSuccess: data => ({
      type: actions.LOAD_SUCCESS,
      payload: data,
    }),

    loadMoreSuccess: data => ({
      type: actions.LOAD_MORE_SUCCESS,
      payload: data,
    }),

    clearStore: () => ({
      type: actions.CLEAR_STORE,
    }),
  };

  return actions;
};

export default getActionsByDocument;
